<template>
    <div class="related-posts" v-if="posts.length">
        <div class="slider-blog">
            <h3 class="font-balo title-slider-blog">
                {{ $t("app.Related posts") }}
            </h3>
            <slick
                :options="slickOptions"
                tag="div"
                class="row list-slider-post"
            >
                <div
                    class="it-post"
                    v-for="(item, index) in posts"
                    :key="index"
                >
                    <div
                        class="feature-blog"
                        :style="{ backgroundImage: `url(${item.image})` }"
                    >
                        <router-link :to="`/blog/${item.id}`"></router-link>
                    </div>
                    <div class="description-blog">
                        <h3>
                            <router-link :to="`/blog/${item.id}`">{{
                                item.title
                            }}</router-link>
                        </h3>
                        <p v-html="item.content"></p>
                        <div class="time-post">{{ item.date }}</div>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
export default {
    name: "RelatedPosts",
    props: ["posts"],
    components: { Slick },
    data() {
        return {
            slickOptions: {
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        };
    }
};
</script>
